import { FC } from "react";

import { CrudEditContextWrapper } from "@ryde/controls";
import { StationRouteContext } from "@ryde/redux";
import {
  IInjectedDrawerProps,
  IStationRouteDto,
  IStationRouteEditDrawerProps,
} from "@ryde/shared";

import {
  StationRouteEditContent,
  StationRouteEditFormTagWrapper,
} from "../../../layout-edit";

export const StationRouteEditFormDrawer: FC<
  IStationRouteEditDrawerProps & IInjectedDrawerProps
> = ({
  resolveFn,
  onCloseDrawer,
  mode,
  id,
  idCopyFrom,
  drawerNumber,
  rideOpenerId,
  type,
}) => {
  return (
    <CrudEditContextWrapper<IStationRouteDto>
      entity="stationRoute"
      mode={mode}
      id={id}
      idCopyFrom={idCopyFrom}
    >
      <StationRouteContext.Provider value={{ rideOpenerId }}>
        <StationRouteEditFormTagWrapper>
          <StationRouteEditContent
            type={type}
            resolveFn={resolveFn}
            onCloseDrawer={onCloseDrawer}
            drawerNumber={drawerNumber}
          />
        </StationRouteEditFormTagWrapper>
      </StationRouteContext.Provider>
    </CrudEditContextWrapper>
  );
};
